import { render, staticRenderFns } from "./Fourth.vue?vue&type=template&id=5eac1973&scoped=true"
import script from "./Fourth.vue?vue&type=script&lang=js"
export * from "./Fourth.vue?vue&type=script&lang=js"
import style0 from "./Fourth.vue?vue&type=style&index=0&id=5eac1973&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eac1973",
  null
  
)

export default component.exports